module.exports = __webpack_public_path__ + "img/youtube.fea0933a.png";